import WaitingListHero from "../components/pagesComponents/waitingListPageComponents/WaitingListHero"
import Perks from "../components/pagesComponents/waitingListPageComponents/Perks"
import SignupForm from "../components/pagesComponents/waitingListPageComponents/WaitingListSignUpForm"
// import Footer from "../components/layoutComponents/footer/Footer"

export default function WaitingList () {
    return (
        <>
            <WaitingListHero/>
            <Perks/>
            <SignupForm/>
        </>
    )
}